import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
export default (function (params) {
  let apiUrl = `/api/alarm/monitor/config`;
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_ALARAM_MONITOR_PUT',
    method: 'PUT',
    manual: false,
  })
  useEffect(() => {
    if (params && params !== null) {
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          apiUrl += '?';
        } else {
          apiUrl += '&';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        apiUrl += `${key}=${params[key]}`;
      });
      exec(apiUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [exec, isRequestSuccessed];
})